import { render, staticRenderFns } from "./OtherHotelProducts.vue?vue&type=template&id=3a839bdc&scoped=true"
import script from "./OtherHotelProducts.vue?vue&type=script&lang=js"
export * from "./OtherHotelProducts.vue?vue&type=script&lang=js"
import style0 from "./OtherHotelProducts.vue?vue&type=style&index=0&id=3a839bdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a839bdc",
  null
  
)

export default component.exports